import { Box, Collapse, Divider, useTheme, ClickAwayListener } from '@mui/material';
import { useContext, useState } from 'react';
import { DrawerContext, DrawerValues } from '../../contexts/DrawerContext';
import { LayeredNavGroup } from '../LayeredNavGroup';
import { UserNavItemsList } from './UserNavItemsList';
import { StoreDisplay } from './StoreDisplay';

interface MobileFooterProps {
  onLogOut: () => void,
  onSwitchStore: () => void,
}

export const MobileFooter = ({ onLogOut, onSwitchStore }: MobileFooterProps) => {
  const theme = useTheme();
  const [collapsed, setCollapsed] = useState(true);
  const { systemNavItemsToUse, setSelectedNavItem } = useContext(DrawerContext) as DrawerValues;

  return <ClickAwayListener onClickAway={() => { if (!collapsed) setCollapsed(true); }}>
    <Box
      borderRadius={3}
      bgcolor={!collapsed ? theme.palette.primary[400] : 'transparent'}
      p={0}
      my={3}
      bottom={0}
      marginBottom='12px'
      width={'100%'}
      sx={{ cursor: 'pointer' }}
    >
      <Collapse in={!collapsed}
        sx={{ marginTop: '4px' }}>
        <LayeredNavGroup navItemList={systemNavItemsToUse} />
        <UserNavItemsList logOutOnClick={onLogOut}
          switchStoreOnClick={onSwitchStore} />
      </Collapse>
      {!collapsed && <Divider
        variant={'middle'}
        color={theme.palette.custom.gray[300]}
        sx={{
          margin: 'auto',
          width: '100%',
        }}
      />}
      <Box
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        sx={{ padding: '0 6px' }}
        onClick={() => {
          if (collapsed) setSelectedNavItem(undefined);
          setCollapsed(prev => !prev);
        }}
      >
        <StoreDisplay onSwitchStore={() => setCollapsed(prev => !prev)} />
      </Box >
    </Box>
  </ClickAwayListener>;
};